import type { Language } from '../types/document'
import type { LegalCopy } from './types'
import { en } from './content/en'
import { hi } from './content/hi'
import { bn } from './content/bn'
import { mr } from './content/mr'
import { ta } from './content/ta'
import { te } from './content/te'
import { gu } from './content/gu'
import { kn } from './content/kn'
import { ml } from './content/ml'
import { pa } from './content/pa'
import { or } from './content/or'
import { asm } from './content/as'

export type { LegalCopy, LegalTopicId } from './types'

// Bundled like the explanation packs, so the legal page works offline in every language
const COPY: Record<Language, LegalCopy> = { hi, en, bn, mr, ta, te, gu, kn, ml, pa, or, as: asm }

export const legalCopy = (language: Language): LegalCopy => COPY[language] ?? hi
